"use client"

import { Button } from "../ui/3d-button"
import { IconCheck } from "@tabler/icons-react"
import { motion } from "framer-motion"

export function CTASection() {
  return (
    <section className="py-24 px-6 bg-secondary">
      <div className="max-w-5xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="relative bg-background rounded-3xl border-4 border-b-8 border-border shadow-2xl overflow-hidden"
        >
          {/* Decorative gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent pointer-events-none" />

          <div className="relative px-8 py-16 md:px-16 md:py-20 text-center">
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="font-serif text-4xl md:text-5xl font-bold mb-6"
            >
              Прекратите терять клиентов прямо сейчас
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="text-lg text-muted-foreground max-w-2xl mx-auto mb-8 leading-relaxed"
            >
              Присоединяйтесь к 500+ брендам, которые уже автоматизировали Instagram сообщения и освободили 20+ часов в
              неделю
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="flex flex-col sm:flex-row gap-4 justify-center items-center"
            >
              <Button size="lg" className="rounded-full px-10">
                Начать 7-дневный бесплатный период
              </Button>
              <Button size="lg" variant="outline" className="rounded-full px-10 bg-transparent">
                Посмотреть 2-минутное демо
              </Button>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.6 }}
              className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-muted-foreground mt-6"
            >
              <span className="flex items-center gap-2">
                <IconCheck className="w-4 h-4 text-accent" />
                Настройка за 5 минут
              </span>
              <span className="flex items-center gap-2">
                <IconCheck className="w-4 h-4 text-accent" />
                Кредитная карта не требуется
              </span>
              <span className="flex items-center gap-2">
                <IconCheck className="w-4 h-4 text-accent" />
                30-дневная гарантия возврата денег
              </span>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
